<template>
  <md-button :class="`md-info md-sm w-auto help ${active}`" v-on:click="click">
    <img :src="require(`@/assets/icons/${img}.png`)" alt="ireal icon" />
  </md-button>
</template>

<script>
export default {
  name: "help-widget",
  props: ["img", "help", "selected"],
  methods: {
    click() {
      this.$emit("click");
    }
  },
  computed: {
    help_ui() {
      return this.help !== undefined ? this.$t(this.help) : "";
    },
    active() {
      return this.selected ? "active" : "";
    }
  }
};
</script>
<style scoped>
.help {
  margin-left: 5px;
}
.badge-default:hover,
.badge-default:focus,
.badge-default:active {
  background: #068bea;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
  transition: all 0.1s ease-in-out;
}
.active {
  background: #068bea;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-3px);
  transition: all 0.1s ease-in-out;
}
</style>
